import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { IconButton, Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

const ICON_SIZE = 24;

type BottomActionsRowProps = {
	playbackSpeed: number;
	isBookmarked: boolean;
	compact?: boolean;
	onChangeSpeed: () => void;
	onToggleBookmark: () => void;
};

const BottomActionsRow = ({
	playbackSpeed,
	isBookmarked,
	compact,
	onChangeSpeed,
	onToggleBookmark,
}: BottomActionsRowProps) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			justifyContent={compact ? undefined : "center"}
			width={compact ? undefined : "100%"}
			paddingHorizontal={compact ? 0 : 4}
			gap={compact ? 12 : 24}
		>
			<IconButton
				icon={() => (
					<Text
						variant="labelLarge"
						style={{ color: theme.colors.onSurfaceVariant }}
					>
						{`${playbackSpeed.toFixed(1)}x`}
					</Text>
				)}
				size={ICON_SIZE}
				onPress={onChangeSpeed}
				style={styles.actionButton}
				accessibilityLabel={t("podcast.a11y.playbackSpeed", {
					speed: playbackSpeed.toFixed(1),
				})}
			/>
			<IconButton
				icon={isBookmarked ? "bookmark" : "bookmark-outline"}
				size={ICON_SIZE}
				onPress={onToggleBookmark}
				iconColor={theme.colors.onSurfaceVariant}
				style={styles.actionButton}
				accessibilityLabel={
					isBookmarked
						? t("podcast.a11y.removeBookmark")
						: t("podcast.a11y.addBookmark")
				}
			/>
		</Box>
	);
};

const styles = StyleSheet.create({
	actionButton: {
		width: 48,
		height: 48,
	},
});

export default BottomActionsRow;
